<div class="pageTitle">
  Admin: Beneficiaries
</div>

<div class="titleSpacerBelow">&nbsp;</div>

<div class="sectionContainer">

  <div class="sectionHeader">
    <div class="sectionTitle">
      Admin : Beneficiaries
    </div>

    <ng-container>
      <!-- SEARCH FIELDS -->
      <div class="search-fields-row">

        <div class="search-field search-field-large">
          <label>Beneficiary Name</label>
          <div class="input-with-clear">
            <input type="text"
                   [(ngModel)]="beneficiarySearchQuery.beneficiaryName"
                   (keydown)="onBeneficiarySearchKeydown($event)"
                   placeholder="Enter beneficiary name"
                   class="search-input" />
            <button type="button" class="clear-input-btn"
                    [disabled]="!beneficiarySearchQuery.beneficiaryName"
                    (click)="beneficiarySearchQuery.beneficiaryName=''; onBeneficiarySearch()">
              ×
            </button>
          </div>
        </div>

        <div class="search-field search-field-urn">
          <label>URN</label>
          <div class="input-with-clear">
            <input type="text"
                   [(ngModel)]="beneficiarySearchQuery.beneficiaryURN"
                   (keydown)="onBeneficiarySearchKeydown($event)"
                   class="search-input" />
            <button type="button" class="clear-input-btn"
                    [disabled]="!beneficiarySearchQuery.beneficiaryURN"
                    (click)="beneficiarySearchQuery.beneficiaryURN=''; onBeneficiarySearch()">
              ×
            </button>
          </div>
        </div>

        <div class="search-field search-field-postcode">
          <label>Postcode</label>
          <div class="input-with-clear">
            <input type="text"
                   [(ngModel)]="beneficiarySearchQuery.postcode"
                   (keydown)="onBeneficiarySearchKeydown($event)"
                   class="search-input" />
          </div>
        </div>

        <div class="search-field search-field-address">
          <label>Address</label>
          <div class="input-with-clear">
            <input type="text"
                   [(ngModel)]="beneficiarySearchQuery.address"
                   (keydown)="onBeneficiarySearchKeydown($event)"
                   class="search-input" />
          </div>
        </div>

        <div class="search-field search-field-button">
          <label>&nbsp;</label>
          <button class="search-btn" (click)="onBeneficiarySearch()">Search</button>
        </div>

        <div class="search-field search-field-button">
          <button mat-raised-button class="addButton" (click)="addBeneficiary()">
            Add beneficiary
          </button>
        </div>

      </div>

      <!-- SEARCH RESULTS AS EXPANDABLE PANELS -->

      <div class="paginator-row">
        <mat-paginator #paginator
                       [length]="beneficiaries.length"
                       [pageSize]="pageSize"
                       [pageSizeOptions]="[50, 100, 200, 500]"
                       (page)="pageChanged($event)"
                       showFirstLastButtons>
        </mat-paginator>
      </div>

      <div *ngIf="tableBeneficiaries.data?.length === 0" class="no-results">No beneficiaries found</div>
      <!-- Header row to align with expansion panel header columns -->
      <div class="beneficiary-list">

        <!-- Header -->
        <div class="beneficiary-row header">
          <div class="col urn">URN</div>
          <div class="col name">Name</div>
          <div class="col address">Address</div>
          <div class="col status">Active</div>
          <div class="col status">IsClient</div>
          <div class="col actions">Actions</div>
        </div>

        <!-- Rows -->
        <div class="beneficiary-row"
             *ngFor="let beneficiary of pagedBeneficiaries">

          <div class="col urn mono">
            {{ beneficiary.beneficiarySourceURN }}
          </div>

          <div class="col name">
            {{ beneficiary.name || '(no name)' }}
          </div>

          <div class="col address">
            <pre class="address-text">
{{ formatAddress(beneficiary) }}
      </pre>
          </div>

          <div class="col status">
            <span class="status-pill"
                  [class.active]="beneficiary.active"
                  [class.inactive]="!beneficiary.active">
              {{ beneficiary.active ? 'Active' : 'Inactive' }}
            </span>
          </div>

          <div class="col status">
            <span class="status-pill"
                  [class.active]="beneficiary.active"
                  [class.inactive]="!beneficiary.active">
              {{ beneficiary.isClient ? 'Yes' : 'No' }}
            </span>
          </div>

          <div class="col actions">
            <button mat-icon-button (click)="editBeneficiary(beneficiary)">
              <mat-icon>edit</mat-icon>
            </button>

            <button mat-icon-button (click)="deleteBeneficiary(beneficiary)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>

        </div>

      </div>


    </ng-container>


  </div>


</div>
